import { render, staticRenderFns } from "./ym-seedling-details.vue?vue&type=template&id=52a80913&scoped=true&"
import script from "./ym-seedling-details.vue?vue&type=script&lang=js&"
export * from "./ym-seedling-details.vue?vue&type=script&lang=js&"
import style0 from "./ym-seedling-details.vue?vue&type=style&index=0&id=52a80913&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a80913",
  null
  
)

export default component.exports